// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderMobile_container__3-005","logo":"HeaderMobile_logo__1v_j0"};